import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithRetry } from "./base-query";

/**
 * Base API configuration that can be extended by different service APIs
 * This provides a centralized configuration for all API slices
 */
export const baseApi = createApi({
  reducerPath: "api",
  baseQuery: baseQueryWithRetry,
  tagTypes: [
    // Survey-related tags
    "IngestionSurvey",
    "AggregationSurvey",
    "ImportJob",
    "UpdateCadence",
    // Add more tag types here as you add more services
    "User",
    "Settings",
    "Dataset",
    "Dashboard",
    "DashboardLayout",
    "DashboardTabs",
    "Clients",
    "WidgetImage",
    // ... other future service tags
  ],
  endpoints: () => ({}), // Empty endpoints - will be injected by service APIs
});

// Export the base API for extension by service-specific APIs
export default baseApi;
